import { CommonModule } from "@angular/common";
import { AccessManagerCfgService } from "../auth/accessManager/accessManagerCfg.service";
import { SigV4CfgService } from "../auth/aws/sigv4Cfg.service";
import { GoogleLoginCfgService } from "../auth/google/googleLoginCfg.service";
import { FeaturePermissionsCfgService } from "../auth/raas/featurePermissionsCfg.service";
import { AppLinksCfgService } from "../common/appLinks/appLinksCfg.service";
import { AppLinksProfessionalsCfgService } from "../common/appLinks/appLinksProfessionalsCfg.service";
import { HeaderCfgService } from "../common/header/headerCfg.service";
import { HelpCfgService } from "../common/help/helpCfg.service";
import { LauncherCfgService } from "../common/launcher/launcherCfg.service";
import { LoggerCfgService } from "../common/logging/loggerCfg.service";
import { NotificationHubCfgService } from "../common/notificationHub/notificationHubCfg.service";
import { OfficeSelectorCfgService } from "../common/officeSelector/officeSelectorCfg.service";
import { CommonCfgService } from "../common/rest/common-cfg.service";
import { SmsCfgService } from "../common/sms/smsCfg.service";
import { VersionService } from "../common/versioning/version.service";
import { DashboardRecruitmentModule } from "../dashboard-recruitment/dashboard-recruitment.module";
import { DashboardCommonModule } from "../dashboardCommon/dashboardCommon.module";
import { NoveltiesModule } from "../novelties/novelties.module";
import { VacanciesModule } from "../vacancies/vacancies.module";
import { DynamicComponentFactoryBuilderService } from "./dynamicComponentFactoryBuilder.service";
import { ServerAddressesCfgService } from "./serverAddressesCfg.service";
import { CommonModule as AngularCommonModule } from '@angular/common';
import { AbsencesKpiCfgService } from "../dashboard/kpi/services/absencesKpi/absencesKpiCfg.service";
import { DashboardRecruitmentCfgService } from "../dashboard-recruitment/services/dashboard-recruitment-cfg.service";
import { DashboardCfgService } from "../dashboard/dashboardCfg.service";
import { AdministrativeManagementDigitalizationKpiCfgService } from "../dashboard/kpi/services/administrativeManagementDigitalizationKpi/administrativeManagementDigitalizationKpiCfg.service";
import { BucketStatusKpiCfgService } from "../dashboard/kpi/services/bucketStatusKpi/bucketsStatusKpiCfg.service";
import { ContractsKpiCfgService } from "../dashboard/kpi/services/contractsKpi/contractsKpiCfg.service";
import { DiscontinuousPermanentWorkersKpiCfgService } from "../dashboard/kpi/services/discontinuousPermanentWorkersKpi/discontinuousPermanentWorkersKpiCfg.service";
import { MonthlyTargetsKpiCfgService } from "../dashboard/kpi/services/monthlyTargetsKpi/monthlyTargetsKpiCfg.service";
import { OccupationalRiskPreventionKpiCfgService } from "../dashboard/kpi/services/occupationalRiskPreventionKpi/occupationalRiskPreventionKpiCfg.service";
import { OffersInNegotiationKpiCfgService } from "../dashboard/kpi/services/offersInNegotiationKpi/offersInNegotiationKpiCfg.service";
import { OrdersKpiCfgService } from "../dashboard/kpi/services/ordersKpi/ordersKpiCfg.service";
import { PendingOrdersFDKpiCfgService } from "../dashboard/kpi/services/pendingOrdersFDKpi/pendingOrdersFDKpiCfg.service";
import { VisitsCallsTargetsKpiCfgService } from "../dashboard/kpi/services/visitsCallsTargetsKpi/visitsCallsTargetsKpiCfg.service";
import { WorkersAppealKpiCfgService } from "../dashboard/kpi/services/workersAppealKpi/workersAppealKpiCfg.service";
import { AbsencesDirectKpiCfgService } from "../dashboardDirect/kpi/services/absencesKpi/absencesDirectKpiCfg.service";
import { ContractsDirectKpiCfgService } from "../dashboardDirect/kpi/services/contractsKpi/contractsDirectKpiCfg.service";
import { OccupationalRiskPreventionDirectKpiCfgService } from "../dashboardDirect/kpi/services/occupationalRiskPreventionKpi/occupationalRiskPreventionDirectKpiCfg.service";
import { NoveltyCfgService } from "../novelties/services/novelty-cfg.service";
import { VacanciesKpiCfgService } from "../vacancies/services/vacanciesKpiCfg.service";
import { DialogModule } from "../common/dialog.module";
import { LoadingOverlayModule } from "../common/loading-overlay.module";
import { NoveltyUserModel } from "../novelties/models/novelty.model";
import { PowerBiCfgService } from "../common/launcher/powerbi/services/powerbi-cfg.service";
import { ShowPowerBiCfgService } from './../common/launcher/powerbi/services/showPowerbi-cfg.service';
import { ImpersonationService } from "../auth/apigee/impersonation.service";
import { ImpersonationCfgService } from "../auth/apigee/impersonationCfg.service";
import { ApigeeCfgService } from "../auth/apigee/apigee-cfg.service";

// Crea una función modular para encapsular las inicializaciones
export async function initializeCoreServices(
  accessManagerCfgService: AccessManagerCfgService,
  initializeRaas: () => Promise<void>,
  featurePermissionsCfgService: FeaturePermissionsCfgService,
  sigv4CfgService: SigV4CfgService,
  appLinksCfgService: AppLinksCfgService,
  appLinksProfessionalsCfgService: AppLinksProfessionalsCfgService,
  officeSelectorCfgService: OfficeSelectorCfgService,
  helpCfgService: HelpCfgService,
  launcherCfgService: LauncherCfgService,
  smsCfgService: SmsCfgService,
  notificationHubCfgService: NotificationHubCfgService,
  absencesKpiCfgService: AbsencesKpiCfgService, dashboardCfgService: DashboardCfgService,
  administrativeManagementDigitalizationKpiCfgService: AdministrativeManagementDigitalizationKpiCfgService, bucketStatusKpiCfgService: BucketStatusKpiCfgService,
  contractsKpiCfgService: ContractsKpiCfgService, occupationalRiskPreventionKpiCfgService: OccupationalRiskPreventionKpiCfgService,
  offersInNegotiationKpiCfgService: OffersInNegotiationKpiCfgService, ordersKpiCfgService: OrdersKpiCfgService, visitsCallsTargetsKpiCfgService: VisitsCallsTargetsKpiCfgService,
  monthlyTargetsCfgService: MonthlyTargetsKpiCfgService, discontinuousPermanentWorkersKpiCfgService: DiscontinuousPermanentWorkersKpiCfgService,
  workersAppealKpiCfgService: WorkersAppealKpiCfgService, pendingOrdersFDKpiCfgService: PendingOrdersFDKpiCfgService, vacanciesKpiCfgService: VacanciesKpiCfgService,
  contractsDirectKpiCfgService: ContractsDirectKpiCfgService, occupationalRiskPreventionDirectKpiCfgService: OccupationalRiskPreventionDirectKpiCfgService,
  absencesDirectKpiCfgService: AbsencesDirectKpiCfgService, dashboardRecruitmentCfgService: DashboardRecruitmentCfgService,
  commonCfgService: CommonCfgService, noveltyCfgService: NoveltyCfgService, powerBiCfgService: PowerBiCfgService, showPowerBiCfgService: ShowPowerBiCfgService
): Promise<void> {
  await Promise.all([
    accessManagerCfgService.initialize(),
    initializeRaas(),
    featurePermissionsCfgService.initialize(),
    sigv4CfgService.initialize(),
    appLinksCfgService.initialize(),
    appLinksProfessionalsCfgService.initialize(),
    officeSelectorCfgService.initialize(),
    helpCfgService.initialize(),
    launcherCfgService.initialize(),
    smsCfgService.initialize(),
    notificationHubCfgService.initialize(),
    absencesKpiCfgService.initialize(),
    dashboardCfgService.initialize(),
    administrativeManagementDigitalizationKpiCfgService.initialize(),
    bucketStatusKpiCfgService.initialize(),
    contractsKpiCfgService.initialize(),
    occupationalRiskPreventionKpiCfgService.initialize(),
    offersInNegotiationKpiCfgService.initialize(),
    ordersKpiCfgService.initialize(),
    visitsCallsTargetsKpiCfgService.initialize(),
    monthlyTargetsCfgService.initialize(),
    discontinuousPermanentWorkersKpiCfgService.initialize(),
    workersAppealKpiCfgService.initialize(),
    pendingOrdersFDKpiCfgService.initialize(),
    vacanciesKpiCfgService.initialize(),
    contractsDirectKpiCfgService.initialize(),
    occupationalRiskPreventionDirectKpiCfgService.initialize(),
    absencesDirectKpiCfgService.initialize(),
    dashboardRecruitmentCfgService.initialize(),
    commonCfgService.initialize(),
    noveltyCfgService.initialize(),
    powerBiCfgService.initialize(),
    showPowerBiCfgService.initialize()
  ]);
}

export function initAppModule(serverAddressesCfgService: ServerAddressesCfgService, versionService: VersionService, dynamicComponentFactoryBuilderService: DynamicComponentFactoryBuilderService,
  googleLoginCfgService: GoogleLoginCfgService, apigeeCfgService: ApigeeCfgService, impersonationCfgService: ImpersonationCfgService, accessManagerCfgService: AccessManagerCfgService,
  impersonationService: ImpersonationService, featurePermissionsCfgService: FeaturePermissionsCfgService, sigv4CfgService: SigV4CfgService,
  appLinksCfgService: AppLinksCfgService, appLinksProfessionalsCfgService: AppLinksProfessionalsCfgService,
  officeSelectorCfgService: OfficeSelectorCfgService, headerCfgService: HeaderCfgService, helpCfgservice: HelpCfgService,
  loggerCfgService: LoggerCfgService, launcherCfgService: LauncherCfgService, smsCfgService: SmsCfgService,
  notificationHubCfgService: NotificationHubCfgService,
  absencesKpiCfgService: AbsencesKpiCfgService, dashboardCfgService: DashboardCfgService,
  administrativeManagementDigitalizationKpiCfgService: AdministrativeManagementDigitalizationKpiCfgService, bucketStatusKpiCfgService: BucketStatusKpiCfgService,
  contractsKpiCfgService: ContractsKpiCfgService, occupationalRiskPreventionKpiCfgService: OccupationalRiskPreventionKpiCfgService,
  offersInNegotiationKpiCfgService: OffersInNegotiationKpiCfgService, ordersKpiCfgService: OrdersKpiCfgService, visitsCallsTargetsKpiCfgService: VisitsCallsTargetsKpiCfgService,
  monthlyTargetsCfgService: MonthlyTargetsKpiCfgService, discontinuousPermanentWorkersKpiCfgService: DiscontinuousPermanentWorkersKpiCfgService,
  workersAppealKpiCfgService: WorkersAppealKpiCfgService, pendingOrdersFDKpiCfgService: PendingOrdersFDKpiCfgService, vacanciesKpiCfgService: VacanciesKpiCfgService,
  contractsDirectKpiCfgService: ContractsDirectKpiCfgService, occupationalRiskPreventionDirectKpiCfgService: OccupationalRiskPreventionDirectKpiCfgService,
  absencesDirectKpiCfgService: AbsencesDirectKpiCfgService, dashboardRecruitmentCfgService: DashboardRecruitmentCfgService,
  commonCfgService: CommonCfgService, noveltyCfgService: NoveltyCfgService, powerBiCfgService: PowerBiCfgService, showPowerBiCfgService: ShowPowerBiCfgService
) {

  let initializeRaas: () => Promise<void> = async () => {
    await impersonationCfgService.initialize();
    await impersonationService.initialize();
  };

  return () =>
    Promise.all([
      googleLoginCfgService.initialize(),
      loggerCfgService.initialize(),
      new Promise<void>(resolve => {
        headerCfgService.initialize().then(async _ => {
          await versionService.initialize()

          resolve();
        })
      }),
      dynamicComponentFactoryBuilderService.initialize([
        AngularCommonModule,
        DialogModule,
        LoadingOverlayModule,
        NoveltyUserModel,
        CommonModule,
        DashboardCommonModule,
        NoveltiesModule,
        DashboardRecruitmentModule,
        VacanciesModule
      ]),
      new Promise<void>(resolve => {
        apigeeCfgService.initialize().then(async _ => {
          serverAddressesCfgService.url = apigeeCfgService.getCfg().url;

          serverAddressesCfgService.initialize().then(async _ => {
            if (serverAddressesCfgService.getData() != undefined) {
              await initializeCoreServices(
                accessManagerCfgService,
                initializeRaas,
                featurePermissionsCfgService,
                sigv4CfgService,
                appLinksCfgService,
                appLinksProfessionalsCfgService,
                officeSelectorCfgService,
                helpCfgservice,
                launcherCfgService,
                smsCfgService,
                notificationHubCfgService,
                absencesKpiCfgService,
                dashboardCfgService,
                administrativeManagementDigitalizationKpiCfgService,
                bucketStatusKpiCfgService,
                contractsKpiCfgService,
                occupationalRiskPreventionKpiCfgService,
                offersInNegotiationKpiCfgService,
                ordersKpiCfgService,
                visitsCallsTargetsKpiCfgService,
                monthlyTargetsCfgService,
                discontinuousPermanentWorkersKpiCfgService,
                workersAppealKpiCfgService,
                pendingOrdersFDKpiCfgService,
                vacanciesKpiCfgService,
                contractsDirectKpiCfgService,
                occupationalRiskPreventionDirectKpiCfgService,
                absencesDirectKpiCfgService,
                dashboardRecruitmentCfgService,
                commonCfgService,
                noveltyCfgService,
                powerBiCfgService,
                showPowerBiCfgService
              );
            }

            resolve()
          });
        })
      })
    ]);
}
